import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { ArrowDownIcon } from 'lucide-react';
const StrategyCard = ({
  title,
  description
}: {
  title: string;
  description: string;
}) => <div className="p-4 sm:p-5 rounded-xl bg-slate-50 border border-slate-200 shadow-sm" data-id="element-97">
    <h3 className="text-sm sm:text-lg font-bold text-gold-600 mb-1 sm:mb-2" data-id="element-98">
      {title}
    </h3>
    <p className="text-xs sm:text-sm text-slate-600 leading-relaxed" data-id="element-99">
      {description}
    </p>
  </div>;
export function ContentStrategy() {
  return <SlideLayout data-id="element-100">
      <div className="mb-6 sm:mb-10" data-id="element-101">
        <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full" data-id="element-102" />
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-103">
          Content & On-Site SEO Strategy
        </h2>
      </div>

      <div className="flex flex-col lg:flex-row gap-6 sm:gap-12" data-id="element-104">
        {/* Left Content */}
        <div className="w-full lg:w-1/2 space-y-3 sm:space-y-4" data-id="element-105">
          <StrategyCard title="Service Pages → Commercial Intent" description="Dedicated service pages target high-intent keywords like 'mortgage broker Kingston' and 'refinancing rates' — capturing visitors ready to take action." data-id="element-106" />
          <StrategyCard title="Blog Content → Informational Intent" description="Educational blog posts target questions like 'how to qualify for a mortgage' — building authority and nurturing future clients." data-id="element-107" />
          <StrategyCard title="Internal Linking → Authority Flow" description="Strategic internal links connect blog content to service pages, passing SEO authority and guiding readers toward conversion." data-id="element-108" />
          <StrategyCard title="Content Restructuring" description="Some existing content is misaligned with search intent. Restructuring ensures every page serves a clear purpose in your SEO strategy." data-id="element-109" />
        </div>

        {/* Right Funnel Visual */}
        <div className="w-full lg:w-1/2 flex flex-col items-center justify-center py-4 sm:py-8" data-id="element-110">
          <div className="w-full max-w-sm sm:max-w-md flex flex-col items-center" data-id="element-111">
            {/* Top Funnel */}
            <div className="w-full bg-slate-100 border border-slate-200 rounded-t-2xl p-4 sm:p-6 text-center relative shadow-sm" data-id="element-112">
              <h4 className="text-base sm:text-xl font-bold text-slate-900 mb-0.5 sm:mb-1" data-id="element-113">
                Awareness
              </h4>
              <p className="text-xs sm:text-sm text-slate-500" data-id="element-114">
                Blog posts, guides, educational content
              </p>
            </div>

            <div className="w-7 h-7 sm:w-8 sm:h-8 -my-3.5 sm:-my-4 relative z-10 bg-white rounded-full flex items-center justify-center border border-slate-200" data-id="element-115">
              <ArrowDownIcon className="w-3 h-3 sm:w-4 sm:h-4 text-slate-400" data-id="element-116" />
            </div>

            {/* Middle Funnel */}
            <div className="w-[85%] bg-slate-200 border border-slate-300 p-4 sm:p-6 text-center relative shadow-sm" data-id="element-117">
              <h4 className="text-base sm:text-xl font-bold text-slate-900 mb-0.5 sm:mb-1" data-id="element-118">
                Consideration
              </h4>
              <p className="text-xs sm:text-sm text-slate-500" data-id="element-119">
                Service pages, comparison content, location pages
              </p>
            </div>

            <div className="w-7 h-7 sm:w-8 sm:h-8 -my-3.5 sm:-my-4 relative z-10 bg-white rounded-full flex items-center justify-center border border-gold-500/30" data-id="element-120">
              <ArrowDownIcon className="w-3 h-3 sm:w-4 sm:h-4 text-gold-500" data-id="element-121" />
            </div>

            {/* Bottom Funnel */}
            <div className="w-[70%] bg-gradient-to-b from-gold-500/10 to-gold-500/20 border border-gold-500/30 rounded-b-2xl p-4 sm:p-6 text-center relative shadow-[0_10px_40px_rgba(128,80,235,0.1)]" data-id="element-122">
              <h4 className="text-base sm:text-xl font-bold text-gold-600 mb-0.5 sm:mb-1" data-id="element-123">
                Conversion
              </h4>
              <p className="text-xs sm:text-sm text-gold-600" data-id="element-124">
                Application pages, consultation booking, pre-approval
              </p>
            </div>

            <div className="mt-4 sm:mt-8 text-center px-4 sm:px-6 py-2 sm:py-3 rounded-full bg-slate-50 border border-slate-200 shadow-sm" data-id="element-125">
              <p className="text-xs sm:text-sm font-medium text-slate-600" data-id="element-126">
                Every piece of content should guide users toward inquiry and
                application.
              </p>
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}